import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cc29e7a0&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc29e7a0')) {
      api.createRecord('cc29e7a0', component.options)
    } else {
      api.reload('cc29e7a0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cc29e7a0&", function () {
      api.rerender('cc29e7a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/addKnowledge/index.vue"
export default component.exports